import * as React from 'react';
import { useIntl } from 'react-intl';

import AgentLogo from './AgentLogo';
import { useExternalAgent } from './useExternalAgent';
import messages from './messages';
import styles from './ExternalAgentMenu.module.scss';

/**
 * The AI Agent panel's pointer to the header's external-agent button: someone
 * who opened the panel is already thinking about AI, so this is where "you
 * can use FileSpin from Claude too" is found. Same click as the header
 * button — connect first, then open.
 */
export const ExternalAgentPanelLink: React.FC = () => {
  const { formatMessage } = useIntl();
  const { agent, status, openPrimary } = useExternalAgent();
  const values = { agent: agent.name };

  return (
    <div className={styles.panelLink} data-test="external-agent-panel-link">
      <AgentLogo agent={agent.id} className={styles.panelLogo} />
      <span className={styles.panelText}>{formatMessage(messages.panelPrompt, values)}</span>
      <button
        type="button"
        className={styles.panelAction}
        onClick={openPrimary}
        data-test="external-agent-panel-open"
        data-status={status}
      >
        {formatMessage(
          status === 'not_connected' ? messages.connectAgentShort : messages.openIn,
          values,
        )}
      </button>
    </div>
  );
};

export default ExternalAgentPanelLink;
